<template>
  <b-row>
    <b-col>
      <b-card>
        <template #header>
          <strong>公司資料設定</strong>
        </template>
        <b-row>
          <b-col md="6">
            <b-form-group label="公司名稱">
              <b-form-input v-model="data.name"></b-form-input>
            </b-form-group>
            <b-form-group label="公司地址">
              <b-form-input v-model="data.address"></b-form-input>
            </b-form-group>
            <b-form-group label="電子郵箱">
              <b-form-input v-model="data.email"></b-form-input>
            </b-form-group>
            <b-form-group label="統一編號">
              <b-form-input v-model="data.tax"></b-form-input>
            </b-form-group>
            <b-form-group label="網址">
              <b-form-input v-model="data.url"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="傳真">
              <b-form-input v-model="data.fax"></b-form-input>
            </b-form-group>
            <b-form-group label="Line">
              <b-form-input v-model="data.line"></b-form-input>
            </b-form-group>
            <b-form-group label="聯絡電話">
              <b-form-input v-model="data.phone"></b-form-input>
            </b-form-group>
            <b-form-group label="手機號碼">
              <b-form-input v-model="data.mobile"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <template #footer>
          <b-button variant="primary" class="float-right" @click="update()"> 確認修改 </b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "SystemSetting",
  data: () => ({
    loading: true,
    data: {
      name: "",
      address: "",
      email: "",
      tax: "",
      fax: "",
      line: "",
      phone: "",
      mobile: "",
      url: "",
    },
  }),
  mounted() {
    this.getSetting();
  },
  methods: {
    getSetting() {
      this.$http.get("/setting/company").then((response) => {
        if (response.data.success) {
          this.data = response.data.result;
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    update() {
      this.$http.patch("/setting/company", this.data).then((response) => {
        if (response.data.success) {
          this.$notify({ type: "success", text: "更新成功" });
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
      });
    },
  },
};
</script>